module.exports = __webpack_public_path__ + "img/account_report.e6e0ae44.svg";